import React, { useEffect, useMemo, useState } from "react";
import ReactApexChart from "react-apexcharts";
import Auxiliary from "util/Auxiliary";
import ModuleBreadcrumb from "components/Common/ModuleBreadcrumb";
import { Col, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllUser,
  getAttendanceDataSelector,
} from "../../appRedux/selectors/User";
import {
  requestAllUserDetails,
  requestAttendanceGet,
} from "../../appRedux/actions/User";
import styled from "styled-components";

const USER_STANDERED_MAPPING_WITH_INDEX = {
  jr_kg: 0,
  sr_kg: 0,
  1: 0,
  2: 0,
  3: 1,
  4: 1,
  5: 2,
  6: 2,
  7: 3,
  8: 3,
  9: 4,
  10: 4,
};

const Report = () => {
  const Users = useSelector(getAllUser);
  const AttDetails = useSelector(getAttendanceDataSelector);
  const dispatch = useDispatch();

  const usersStdData = useMemo(() => {
    const values =
      Users &&
      !!Users.length &&
      Users.reduce((state, { standard }) => {
        state[USER_STANDERED_MAPPING_WITH_INDEX[standard]]++;
        return state;
      }, Array(5).fill(0));
    return values;
  }, [Users]);

  const fetchingLatestData =
    AttDetails && AttDetails.length && AttDetails.slice(-6);

  const reportDateData = useMemo(() => {
    const reportDate =
      fetchingLatestData &&
      fetchingLatestData?.length &&
      fetchingLatestData.map((data) => {
        return data?.date;
      });
    return {
      reportDate,
    };
  }, [fetchingLatestData]);

  const reportUserData = useMemo(() => {
    const datas =
      fetchingLatestData &&
      fetchingLatestData?.length &&
      fetchingLatestData.map((data) => {
        return data?.users.length;
      });
    return datas;
  }, [fetchingLatestData]);

  useEffect(() => {
    dispatch(requestAttendanceGet({ id: "", date: "" }));
    dispatch(requestAllUserDetails({ q: "" }));
  }, []);

  const state = {
    series: [
      {
        data: reportUserData,
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "bar",
      },
      plotOptions: {
        bar: {
          columnWidth: "45%",
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      xaxis: {
        categories: reportDateData?.reportDate,
        labels: {
          style: {
            fontSize: "14px",
            fontFamily: "Cabin",
          },
        },
      },
    },
  };

  const piestate = {
    series: usersStdData,
    options: {
      chart: {
        width: 800,
        type: "pie",
      },
      labels: [
        "Jr, Sr, 1 & 2",
        "Std 3 & 4",
        "Std 5 & 6",
        "Std 7 & 8",
        "Std 9 & 10",
      ],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 300,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  };

  return (
    <AddUserWrapper>
      <Auxiliary>
        <ModuleBreadcrumb
          title="Nikol Bal-Sabha Report"
          breadcrumbs={["Report", "View"]}
          links={["/report", "/report", ""]}
        />
        <Row className="gx-profile-content">
          <Col span={24}>
            <div className="gx-card">
              <div className="gx-card-body">
                <div>
                  <h4 style={{ paddingLeft: "12px", fontWeight: "600" }}>
                    Day wise analytics
                  </h4>
                  <ReactApexChart
                    options={state.options}
                    series={state.series}
                    type="bar"
                    height={350}
                  />
                </div>
                <div style={{ paddingTop: "20px" }}>
                  <h4 style={{ paddingLeft: "12px", fontWeight: "600" }}>
                    Standard wise analytics
                  </h4>
                  <ReactApexChart
                    options={piestate.options}
                    series={piestate.series}
                    type="pie"
                    width={380}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Auxiliary>
    </AddUserWrapper>
  );
};

const AddUserWrapper = styled.div`
  font-family: "Cabin", sans-serif;
`;
export default Report;
